export default "__VITE_ASSET__BYb8V0Ga__"